<body>
  <div>
    <fieldset aria-labelledby="unauth-heading" role="alert">
      <h3>Unauthorized: Access Authorization Warning.</h3>
      <div class="bodyContent">
        Thank you for using TruStage's Website!<br />
        It appears that you are not authorized to use the service you tried to access. If you recently requested access,
        please wait until you receive your confirmation email.<br /><br />
        <b aria-label="Call TruStage Annuity Solutions Desk at 877-345-4769, option 1"
          >If you continue to have problems, please call the TruStage Annuity Solutions Desk at 877-345-GROW (4769)
          option 1.</b
        ><br />
        <a class="homeurl" href="{{ homeUrl }}">Click here</a> to return to the home page.
        <br />
      </div>
    </fieldset>
    <br />
  </div>
</body>
